import React, { useEffect } from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";
import { MdArrowOutward } from "react-icons/md";

const STATS = [
    { value: "99.9%", label: "Uptime SLA" },
    { value: "< 24hr", label: "Response Time" },
    { value: "24 / 7", label: "Cloud Ops" },
    { value: "Azure", label: "Primary Platform" },
];

const SOCIALS = [
    { icon: FaLinkedin, href: "https://www.linkedin.com/in/raviraj-kumar-019956225", label: "LinkedIn" },
    { icon: FaGithub, href: "https://www.github.com/ravirajkumartiwari", label: "GitHub" },
    { icon: FaSquareXTwitter, href: "https://twitter.com/RaviRaaZ_Tiwari", label: "Twitter / X" },
    { icon: HiOutlineMail, href: "mailto:ravirajk545@gmail.com", label: "Email" },
];

function Contact() {
    useEffect(() => { document.title = "Contact — Raviraj Kumar Tiwari"; }, []);

    return (
        <div className="min-h-screen" style={{ background: "var(--clr-surface)" }}>
            {/* Page Header */}
            <section className="px-6 py-20 section-light">
                <div className="max-w-6xl mx-auto">
                    <p className="section-label mb-4">Let's Connect</p>
                    <h1 className="display-heading max-w-xl">
                        Let's Build Something.
                    </h1>
                    <p className="mt-4 text-on-surface-variant max-w-2xl leading-relaxed">
                        Open to roles where I can grow as a Cloud, Infrastructure, or Monitoring Engineer.
                        If you are building reliable systems and value observability, I'd be happy to connect.
                    </p>
                </div>
            </section>

            {/* Split Layout */}
            <section className="px-6 py-20" style={{ background: "var(--clr-surface)" }}>
                <div className="max-w-6xl mx-auto grid md:grid-cols-[1fr_1.4fr] gap-12">
                    {/* Left — Info */}
                    <div className="flex flex-col gap-10">
                        {/* Email */}
                        <div>
                            <p className="section-label mb-4">Secure Channel</p>
                            <a
                                href="mailto:ravirajk545@gmail.com"
                                className="group inline-flex items-center gap-2 text-base font-medium text-on-surface hover:text-primary transition-colors"
                            >
                                ravirajk545@gmail.com
                                <MdArrowOutward size={16} className="text-on-surface-variant group-hover:text-primary transition-colors" />
                            </a>
                        </div>

                        {/* Social */}
                        <div>
                            <p className="section-label mb-4">Social Graph</p>
                            <div className="flex flex-col gap-3">
                                {SOCIALS.map(({ icon: Icon, href, label }) => (
                                    <a
                                        key={label}
                                        href={href}
                                        target={href.startsWith("mailto") ? undefined : "_blank"}
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-3 text-sm text-on-surface-variant hover:text-primary transition-colors"
                                    >
                                        <Icon size={16} className="flex-shrink-0" />
                                        {label}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Stats */}
                        <div>
                            <p className="section-label mb-6">Response Protocol</p>
                            <div className="grid grid-cols-2 gap-6">
                                {STATS.map(({ value, label }) => (
                                    <div key={label}>
                                        <div className="metric-value text-[1.5rem]">{value}</div>
                                        <div className="metric-label">{label}</div>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-6 text-xs text-on-surface-variant leading-relaxed">
                                Active monitoring 09:00 — 18:00 IST.
                                Expect a response within 24 hours.
                            </p>
                        </div>
                    </div>

                    {/* Right — Form */}
                    <div>
                        <form
                            action="https://getform.io/f/pbmqkedb"
                            method="POST"
                            className="card-node flex flex-col gap-5"
                            style={{ background: "var(--clr-surface-lowest)" }}
                        >
                            <div className="grid sm:grid-cols-2 gap-5">
                                <div className="flex flex-col gap-2">
                                    <label htmlFor="name" className="text-[0.8125rem] font-medium text-on-surface-variant">
                                        Name
                                    </label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        required
                                        placeholder="Your full name"
                                        className="form-input"
                                    />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label htmlFor="email" className="text-[0.8125rem] font-medium text-on-surface-variant">
                                        Email
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        required
                                        placeholder="you@example.com"
                                        className="form-input"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <label htmlFor="subject" className="text-[0.8125rem] font-medium text-on-surface-variant">
                                    Subject
                                </label>
                                <input
                                    id="subject"
                                    name="subject"
                                    type="text"
                                    placeholder="What's this about?"
                                    className="form-input"
                                />
                            </div>

                            <div className="flex flex-col gap-2">
                                <label htmlFor="message" className="text-[0.8125rem] font-medium text-on-surface-variant">
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={6}
                                    required
                                    placeholder="Tell me about your project, role, or say hello…"
                                    className="form-input resize-none"
                                />
                            </div>

                            <button type="submit" className="btn-primary self-start">
                                Send Message <MdArrowOutward size={16} />
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
